// 应用版本号 (由 scripts/sync-version.mjs 从 package.json 自动同步,勿手动改)
export const APP_VERSION = '0.0.19'
